document.addEventListener('click', async function (event) {

  const button = event.target.closest('.upsell-add-btn');

  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;

  if (!variantId) return;

  const originalText = button.innerHTML;

  button.disabled = true;
  button.classList.add('loading');
  button.innerHTML = 'Adding...';

  try {

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!addResponse.ok) {
      throw new Error('Failed to add product');
    }

    const sectionsResponse = await fetch(
      `${window.Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
    );

    if (!sectionsResponse.ok) {
      throw new Error('Failed to reload cart sections');
    }

    const sections = await sectionsResponse.json();

    /**
     * Update Cart Drawer
     */
    if (sections['cart-drawer']) {

      const drawerDoc = new DOMParser().parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const newDrawer = drawerDoc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    }

    /**
     * Update Cart Bubble
     */
    if (sections['cart-icon-bubble']) {

      const bubbleDoc = new DOMParser().parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const newBubble = bubbleDoc.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }

    document.querySelector('cart-drawer')?.classList.remove('is-empty');

  } catch (error) {

    console.error('Upsell Add To Cart Error:', error);

  } finally {

    button.disabled = false;
    button.classList.remove('loading');
    button.innerHTML = originalText;

  }

});